var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.26,11.31c-.38,.37-.21,1.01,.3,1.09l5.79,.89,2.65,5.23c.23,.46,.9,.43,1.13-.05l2.5-5.13,5.73-.77c.54-.07,.77-.74,.39-1.11l-4.22-4.08,.92-5.68c.06-.33-.16-.65-.49-.71-.14-.03-.28,0-.4,.06l-5.12,2.64L4.24,.95c-.47-.25-1.03,.18-.93,.72l1.05,5.68L.26,11.32h0Zm6.64,.76l-4.86-.75,3.43-3.32c.16-.15,.23-.38,.2-.6l-.86-4.69,4.3,2.27c.18,.09,.4,.09,.58,0l4.32-2.23-.77,4.8c-.03,.2,.03,.41,.18,.55l3.49,3.38-4.72,.64c-.22,.03-.41,.17-.51,.37l-2.09,4.29-2.22-4.39c-.09-.17-.25-.29-.44-.32h0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.02,
    y: -1.92,
    width: 1.11,
    height: 24.35,
    rx: 0.56,
    ry: 0.56,
    transform: "translate(-4.45 10.06) rotate(-46.16)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoStar);
export default __webpack_public_path__ + "static/media/no-star.cc00a64e67e4d46add4861b33a31cf7a.svg";
export { ForwardRef as ReactComponent };